import {
  Loader as MantineLoader,
  type LoaderProps as MantineLoaderProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type LoaderProps = CoreComponentProps<MantineLoaderProps, 'div'>;

export function Loader({ testId, view = "all", ...rest }: LoaderProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineLoader data-testid={testId} {...rest} />;
}
